import { ApplicationRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AnalyticsFacade, PageAnalyticParams } from '@amfam/shared/analytics';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { PartnerTermsData } from '@amfam/shared/utility/shared-services';
import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../core/store';
import { TermsComponentDirective } from '../terms.component';

@Component({
  selector: '',
  templateUrl: './go-paperless-terms.component.html',
  styleUrls: ['./go-paperless-terms.component.scss'],
  standalone: false
})
export class GoPaperlessTermsComponent extends TermsComponentDirective implements OnInit {
  public termsPartnerData$: Observable<PartnerTermsData> = this.store.select(
    BrandSelectors.selectPartnerTermsData
  );

  // **** Start of Analytics data for this component
  private pageAnalytic: PageAnalyticParams = {
    pageName: 'MyAccount:Policies:GoPaperlessTC',
    experience: '',
    primaryCategory: 'My Account',
    subCategory1: 'Policies',
    subCategory2: 'Go Paperless',
    subCategory3: ''
  };
  // **** End of Analytics data for this component

  constructor(
    private store: Store<fromRoot.RootState>,
    dockingService: DockingBarService,
    route: ActivatedRoute,
    application: ApplicationRef,
    private analyticsFacade: AnalyticsFacade,
    private pageTitle: PageTitleService
  ) {
    super(dockingService, route, application);
  }

  ngOnInit() {
    const title = 'Go Paperless Policy Service Terms & Conditions';
    this.dockingService.registerHeading(title);
    this.pageTitle.set(title);
    this.analyticsFacade.trackPage(this.pageAnalytic);
  }
}
